import React from 'react';
import { useTranslation } from 'react-i18next';

import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';

function PageNotFound() {
    const { t } = useTranslation();

    return (
        <div>
            <NavigationBar />
            <h1>{t('PAGE_NOT_FOUND_TITLE')}</h1>
            <div className="p-3">
                <p>{t('PAGE_NOT_FOUND_MESSAGE')}</p>
            </div>
            <MediaList mediaKey='PAGE_NOT_FOUND_BOTTOM' maxItems={1}  isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default PageNotFound;